import { render, staticRenderFns } from "./SntUpload.vue?vue&type=template&id=88571cb0&scoped=true&"
import script from "./SntUpload.vue?vue&type=script&lang=js&"
export * from "./SntUpload.vue?vue&type=script&lang=js&"
import style0 from "./SntUpload.vue?vue&type=style&index=0&id=88571cb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88571cb0",
  null
  
)

/* custom blocks */
import block0 from "./SntUpload.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports